import styled from 'styled-components';

export const StyledContainer = styled.div`
  padding: 2rem;

  tbody .ant-table-cell {
    cursor: pointer;
  }
`;
